import loadable from '@loadable/component';
import expertProfileQuery from './query.graphql';

const ExpertProfile = loadable(() =>
  import(/* webpackChunkName: "expert" */ './profile')
);

ExpertProfile.graphQL = expertProfileQuery;

ExpertProfile.variables = ({ slug }) => ({
  slug,
});

export default ExpertProfile;
